// Module
var code = "<div class=\"[[ { '_hidden': !url } ]]\"> <div class=\"abs-layout\"> <div class=\"[[ { '_hidden': !fallbackUrl } ]] media-responsive -media-4-3 abs-layout\"> <iframe class=\"item -stretch\" src=\"[[ fallbackUrl ]]\"></iframe> </div> </div> </div> ";
// Exports
export default code;